import React from 'react'
import Header from '../header/Header'
import Account from './Account'

const Accountpage = () => {
    return (
        <div>
            <Header />
            <Account />
        </div>
    )
}

export default Accountpage